import React from 'react'
import { BarDatum, ResponsiveBarCanvas } from '@nivo/bar'
import { Box } from '@material-ui/core'
import { COLOR_SCHEME_SET1 } from '../calibration/chart-util'
import { BarTooltip } from '../../common/charts/BarTooltip'

type Props = {
  data: BarDatum[]
  keys: string[]
  xFormatter: (id: string) => string
  yFormatter: (value: number) => string
  axisBottomLegend?: string
  axisLeftLegend?: string
  legendItemWidth?: number
  grouped?: boolean
  colors?: string[]
}

export function SummaryBarChart({
  data,
  keys,
  xFormatter,
  yFormatter,
  axisBottomLegend,
  axisLeftLegend,
  legendItemWidth,
  grouped,
  colors,
}: Props): React.ReactElement {
  const colorSet = colors
    ? colors.slice(0, keys.length)
    : COLOR_SCHEME_SET1.slice(0, keys.length)

  return (
    <Box position="relative" height="100%" width="100%">
      <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={0}>
        <ResponsiveBarCanvas
          data={data}
          keys={keys}
          groupMode={grouped ? 'grouped' : 'stacked'}
          isInteractive
          enableLabel={false}
          indexBy="id"
          valueScale={{
            type: 'linear',
            max: 'auto',
            min: 'auto',
          }}
          colors={colorSet}
          margin={{ top: 8, right: 10, bottom: 90, left: 50 }}
          padding={0.7}
          tooltip={({ id, value }) =>
            BarTooltip(xFormatter(String(id)), yFormatter(value))
          }
          axisBottom={{
            legend: axisBottomLegend,
            legendOffset: 35,
          }}
          axisLeft={{
            // format: yFormatter,
            legend: axisLeftLegend,
            legendOffset: -35,
          }}
          layers={['grid', 'bars', 'axes', 'legends']}
          legends={[
            {
              dataFrom: 'keys',
              anchor: 'bottom',
              direction: 'row',
              itemHeight: 10,
              itemWidth: legendItemWidth ?? 100,
              itemsSpacing: 20,
              translateY: 60,
              symbolSize: 20,
            },
          ]}
        />
      </Box>
    </Box>
  )
}
